import {
  sortAscIcon,
  sortDescIcon,
  sortIcon,
} from '../../icons'

import { SortOrderAsc } from '../Mamorio'

const SortKey = {
  Name: 'name',
  Memo: 'memo',
  Time: undefined,
  LastDetectedDevice: 'last_detected_device',
  LastEventLogName: 'event_log_name',
  LastEventLogNameAlias: 'last_event_log_name',
  BatteryLifeRessetedAt: 'battery_life_resetted_at',
  Status: 'status',
}

const getSortIcon = (sort: Nullable<string>, order: Nullable<string>): SortIcons => {
  const defaultIcons: SortIcons = {
    name: sortIcon,
    memo: sortIcon,
    time: sortIcon,
    lastDetectedDevice: sortIcon,
    lastEventLogName: sortIcon,
    batteryLifeResettedAt: sortIcon,
    status: sortIcon,
  }

  const selectedIcon = order === SortOrderAsc ? sortAscIcon : sortDescIcon

  if (sort === SortKey.Name) {
    return { ...defaultIcons, name: selectedIcon }
  }
  if (sort === SortKey.Memo) {
    return { ...defaultIcons, memo: selectedIcon }
  }
  if (sort === SortKey.Time) {
    return { ...defaultIcons, time: selectedIcon }
  }
  if (sort === SortKey.LastDetectedDevice) {
    return { ...defaultIcons, lastDetectedDevice: selectedIcon }
  }
  if (sort === SortKey.LastEventLogName || sort === SortKey.LastEventLogNameAlias) {
    return { ...defaultIcons, lastEventLogName: selectedIcon }
  }
  if (sort === SortKey.BatteryLifeRessetedAt) {
    return { ...defaultIcons, batteryLifeResettedAt: selectedIcon }
  }
  if (sort === SortKey.Status) {
    return { ...defaultIcons, status: selectedIcon }
  }

  return defaultIcons
}

export default getSortIcon
